export function buildApplePayValidateMerchantRequest({ purchaseId, validationUrl, domain }) {
  return {
    purchase_id: purchaseId,
    validation_url: validationUrl,
    domain,
  }
}
